export const aushTypes = {
  AUTH_TITELE1: "AUTH_TITELE1",
  AUTH_TITELE2: "AUTH_TITELE2",
  AUTH_TITELE3: "AUTH_TITELE3",
  AUTH_TITELE4: "AUTH_TITELE4",
  AUTH_TITELE5: "AUTH_TITELE5",
};
